import Moment from 'moment'

function formatTime(time) {
    let formattedTime = {
        'HH' : ('0' + Moment(time, 'HH:mm:ss').hour()).slice(-2),
        'mm' : ('0' + Moment(time, 'HH:mm:ss').minute()).slice(-2),
        'ss' : '00'
    }

    return formattedTime;
}

function timeToString(time) {
    let timeString = time.HH + ':' + time.mm + ':00'
    return timeString;
}

function calculateDuration(currentTime, selectedTime) {

    //console.log('currentTime ' + currentTime);
    //console.log('selectedTime ' + selectedTime);

    let duration = Moment.utc(Moment(selectedTime, "HH:mm:ss").diff(Moment(currentTime, "HH:mm:ss"))).format("HH:mm:ss");
    let formattedDuration = this.formatTime(duration);
    let offset = (parseInt(formattedDuration.HH) * 60) + parseInt(formattedDuration.mm);
    console.log(offset)
    return parseInt(offset);
}



export default {
    formatTime,
    timeToString,
    calculateDuration
}